import { analPBDongTienRequest } from 'containers/market/actions'
import { analNNIndayRequest } from 'containers/market/actions'
import { analIndexRealRequest } from 'containers/market/actions'
import { makeGetAnalPBDongTien } from 'lib/selector'
import { makeGetNNInday } from 'lib/selector'
import { makeGetAnalIndexReal } from 'lib/selector'
import React, { memo } from 'react'
import { connect, useDispatch } from 'react-redux'

import { numberFormat } from 'utils'
import PanelDongTien from '../panelDongTien'
import PanelOverView from '../panelOverview'
import { AlgoSignalContext } from 'containers/socket/signalAlgo'
import { mapIndexList } from 'utils/config'
import * as _ from 'lodash'

function usePrevious(value) {
  const ref = React.useRef()

  React.useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current
}

function OverviewVNIndex(props) {
  const as = React.useContext(AlgoSignalContext)
  const [tabActive, setTabActive] = React.useState('Tong-Hop')
  const [indexToShow, setIndexToShow] = React.useState(null)

  const dispatch = useDispatch()

  const {
    symActive,
    analPBDongTien,
    analIndReal,
    analNNInday,
    t,
    theme,
    algoSignal,
    algoIndex,
    algoIChart,
  } = props

  const preTabActive = usePrevious(tabActive)
  const preAlgoSignal = usePrevious(algoSignal)
  const preSymActive = usePrevious(symActive)
  const preAlgoIndex = usePrevious(algoIndex)
  const preAnalIndReal = usePrevious(analIndReal)

  React.useEffect(() => {
    return () => {
      console.log(symActive, mapIndexList[symActive])

      if (mapIndexList[symActive]) {
        var msg = {
          action: 'leave',
          channelName: 'index-realtime:' + mapIndexList[symActive],
        }
        as.sendMessage(msg)
        msg = {
          action: 'leave',
          channelName: 'index-chart:' + mapIndexList[symActive],
        }
        as.sendMessage(msg)
      }
    }
  }, [])

  React.useEffect(() => {
    console.log(symActive, mapIndexList[symActive])
    if (
      algoSignal &&
      !_.isEqual(algoSignal, preAlgoSignal) &&
      mapIndexList[symActive]
    ) {
      setTimeout(() => {
        var msg = {
          action: 'reg',
          channelName: 'index-realtime:' + mapIndexList[symActive],
        }
        as.sendMessage(msg)
        msg = {
          action: 'reg',
          channelName: 'index-chart:' + mapIndexList[symActive],
        }
        as.sendMessage(msg)
      }, 200)
    }
  }, [algoSignal])

  React.useEffect(() => {
    if (analIndReal && !_.isEqual(analIndReal, preAnalIndReal)) {
      setIndexToShow(analIndReal)
    }
  }, [analIndReal])

  React.useEffect(() => {
    if (
      algoIndex &&
      !_.isEqual(algoIndex, preAlgoIndex) &&
      algoIndex?.FloorID === analIndReal?.FloorID
    ) {
      setIndexToShow(algoIndex)
    }
  }, [algoIndex])

  React.useEffect(() => {
    if (tabActive && tabActive !== preTabActive) {
      switch (tabActive) {
        case 'Tong-Hop':
          dispatch(analIndexRealRequest(symActive))
          dispatch(analNNIndayRequest(symActive))
          break

        case 'Dong-Tien':
          dispatch(analPBDongTienRequest(symActive))
          break

        default:
          break
      }
    }
  }, [tabActive])

  React.useEffect(() => {
    if (
      symActive &&
      !_.isEqual(symActive, preSymActive) &&
      mapIndexList[symActive]
    ) {
      if (preSymActive) {
        var msg
        if (mapIndexList[preSymActive]) {
          msg = {
            action: 'leave',
            channelName: 'index-realtime:' + mapIndexList[preSymActive],
          }
          as.sendMessage(msg)
          msg = {
            action: 'leave',
            channelName: 'index-chart:' + mapIndexList[preSymActive],
          }
          as.sendMessage(msg)
        }

        // register socket realtime
        msg = {
          action: 'reg',
          channelName: 'index-realtime:' + mapIndexList[symActive],
        }
        as.sendMessage(msg)
        msg = {
          action: 'reg',
          channelName: 'index-chart:' + mapIndexList[symActive],
        }
        as.sendMessage(msg)
      }

      dispatch(analIndexRealRequest(symActive))
      dispatch(analNNIndayRequest(symActive))
      dispatch(analPBDongTienRequest(symActive))
    }
  }, [symActive])

  // console.log(algoIndex)
  // console.log(analIndReal)

  return (
    <div
      className="d-flex flex-column w-100 h-100 p-2 analysis-overview "
      style={{ background: 'var(--bg_card_chart)', borderRadius: '2px' }}
    >
      <div className="d-flex justify-content-between">
        <span className="txt-content fz-14">{symActive}</span>
        <span
          className={`color-${
            indexToShow?.Diff > 0
              ? 'up'
              : indexToShow?.Diff < 0
              ? 'down'
              : 'ref'
          }-analysis fz-12`}
        >
          <span style={{ fontWeight: '500' }}>
            {numberFormat(indexToShow?.Index, 2)}
          </span>
          <span className="fz-10 pl-1">{`${numberFormat(
            indexToShow?.Diff,
            2
          )} / ${numberFormat(indexToShow?.DiffRate, 2)}%`}</span>
        </span>
      </div>
      <div className="d-flex mt-2">
        <div
          className={
            'w-50 btn-analysis first ' +
            (tabActive === 'Tong-Hop' ? 'active' : '')
          }
          onClick={() => setTabActive('Tong-Hop')}
        >
          {t('algo.bdkt.txt-overview')}
        </div>
        <div
          className={
            'w-50 btn-analysis second ' +
            (tabActive === 'Dong-Tien' ? 'active' : '')
          }
          onClick={() => setTabActive('Dong-Tien')}
        >
          {t('algo.bdkt.txt-money-flows')}
        </div>
      </div>
      {tabActive === 'Tong-Hop' && symActive && (
        <PanelOverView
          indexDetail={indexToShow}
          nnInday={analNNInday}
          symActive={symActive}
          algoIChart={algoIChart}
          t={t}
          theme={theme}
        />
      )}
      {tabActive === 'Dong-Tien' && (
        <PanelDongTien
          symActive={symActive}
          indexDetail={indexToShow}
          pbDongTien={analPBDongTien}
          t={t}
          theme={theme}
        />
      )}
    </div>
  )
}

const makeMapStateToProps = () => {
  const getAnalIndexReal = makeGetAnalIndexReal()
  const getAnalPBDongTien = makeGetAnalPBDongTien()
  const getNNInday = makeGetNNInday()

  const mapStateToProps = (state) => {
    return {
      analIndReal: getAnalIndexReal(state),
      analPBDongTien: getAnalPBDongTien(state),
      analNNInday: getNNInday(state),
      algoSignal: state.socket.algoSignal,
      algoIndex: state.socket.algoIndex,
      algoIChart: state.socket.algoIChart,
    }
  }
  return mapStateToProps
}

export default connect(makeMapStateToProps)(memo(OverviewVNIndex))
